"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GENESYS_SUPPORT_CENTER_SKELETON = void 0;
const GENESYS_SUPPORT_CENTER_SKELETON = exports.GENESYS_SUPPORT_CENTER_SKELETON = 'genesys-support-center-skeleton';
